import { SmartDmMeasurementParser } from './SmartDmMeasurementParser';
import type { ParsedData } from '../../../../interfaces/toolData';

/**
 * Parser for JAE Smart DM ROUTE files
 * 
 * Handles directional/survey route measurements:
 * - INCLINATION (well inclination angle)
 * - AZIMUTH (well azimuth direction)
 */
export class SmartDmRouteParser {
  static parse(fileContent: string): ParsedData {
    const unitMappings = {
      'INCLINATION': '°',
      'AZIMUTH': '°'
    };
    
    return SmartDmMeasurementParser.parse(
      fileContent,
      'ROUTE',
      'JAE_SMARTDM_ROUTE',
      unitMappings
    );
  }
} 